import { SET_TOKEN } from './constants';

export const setToken = (token, loggedIn) => (dispatch) => {
  dispatch({ type: SET_TOKEN, token, loggedIn });
};
